import React from 'react';
import './WhoIsItFor.css';

const WhoIsItFor: React.FC = () => {
  return (
    <section className="who-is-it-for section" id="who-is-it-for">
      <div className="container">
        <div className="who-is-it-for__header">
          <h2 className="who-is-it-for__title heading-2 text-center">
            Who It Is For
          </h2>
          <p className="who-is-it-for__subtitle text-center">
            Furudio is for organizations where ambition is not the problem.
          </p>
        </div>
        <div className="who-is-it-for__prose">
          <div className="who-is-it-for__item">
            <h3 className="who-is-it-for__item-title">Scaling fast</h3>
            <p className="who-is-it-for__item-description">Growth brings complexity. What worked when everyone sat in the same room stops working when there are eight departments, three locations and a strategy that needs to hold across all of them. Furudio brings the structure that scales with you.</p>
          </div>
          <div className="who-is-it-for__item">
            <h3 className="who-is-it-for__item-title">Navigating change</h3>
            <p className="who-is-it-for__item-description">Restructures, new leadership, shifting priorities. Change creates uncertainty about who owns what and where the organization is headed. Furudio gives everyone a shared view to orient from, so momentum continues through the transition.</p>
          </div>
          <div className="who-is-it-for__item">
            <h3 className="who-is-it-for__item-title">Going through M&amp;A</h3>
            <p className="who-is-it-for__item-description">Two organizations, two cultures, two ways of working. Furudio creates the common ground: shared objectives, visible dependencies, one picture of how the combined organization is performing.</p>
          </div>
          <div className="who-is-it-for__item">
            <h3 className="who-is-it-for__item-title">Breaking down silos</h3>
            <p className="who-is-it-for__item-description">When functions optimize for their own metrics and strategy fragments between departments, the whole organization pays the price. Furudio makes the connections between functions visible and gives people a reason and a structure to work across them.</p>
          </div>
          <div className="who-is-it-for__item">
            <h3 className="who-is-it-for__item-title">Already believing, not yet succeeding</h3>
            <p className="who-is-it-for__item-description">You have invested in data. You talk about collaboration. But the meetings still end without decisions and the strategy still looks better on paper than in practice. Furudio is built for exactly this moment.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhoIsItFor;
